const Store_BuildingBlocks = {
  data: null,
  set: (data) => {
    Store_BuildingBlocks.data = data;
  },
  get: (buldingBlockId) => {
    if (!Store_BuildingBlocks.data) return null;

    return Store_BuildingBlocks.data[buldingBlockId];
  },
};

export default Store_BuildingBlocks;
